// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileUnknownFilledSvg from "@ant-design/icons-svg/es/asn/FileUnknownFilled";
import AntdIcon from '../components/AntdIcon';

var FileUnknownFilled = function FileUnknownFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileUnknownFilledSvg
  }));
};

FileUnknownFilled.displayName = 'FileUnknownFilled';
export default React.forwardRef(FileUnknownFilled);